import { Box, Typography } from '@mui/material';
import React from 'react';
import { bodySx, linkSx, LoginModalShell } from './LoginModalShell';

interface AccountBlockedProps {
  open: boolean;
  isRedirectFromBlockedExpiredPage: boolean;
  handleClose: () => void;
  resetPassword: () => void;
}

export const AccountBlocked: React.FC<AccountBlockedProps> = ({
  open,
  isRedirectFromBlockedExpiredPage,
  handleClose,
  resetPassword,
}) => (
  <LoginModalShell
    open={open}
    onClose={handleClose}
    titleId='account-blocked-title'
    descriptionId='account-blocked-description'
    title={isRedirectFromBlockedExpiredPage ? 'Password link expired' : 'Your account has been locked.'}
  >
    {isRedirectFromBlockedExpiredPage ? (
      <Typography variant='body_02' sx={bodySx}>
        The link you are attempting to use has expired (it has been {'>'}24 hours since you received the email). Please
        contact Karius at{' '}
        <Box component='a' href='tel:8664527487' sx={linkSx}>
          (866) 452-7487
        </Box>
        {', '}
        <Box component='a' href='mailto:help@kariusdx.com' sx={linkSx}>
          help@kariusdx.com
        </Box>{' '}
        to get your account unlocked or reset your password.
      </Typography>
    ) : (
      <Typography component='div' variant='body_02' sx={bodySx}>
        <b>To unlock it:</b>
        <Box component='ul' sx={{ pl: '15px', mt: 0, mb: '21px' }}>
          <li>Check your email for unlock instructions</li>
          <li>
            Or{' '}
            <Box
              component='button'
              type='button'
              onClick={resetPassword}
              sx={{ ...linkSx, cursor: 'pointer', background: 'none', border: 'none', p: 0, font: 'inherit' }}
            >
              reset your password
            </Box>{' '}
            to unlock your account
          </li>
        </Box>
        <b>Need help?</b>
        <Box>
          Call{' '}
          <Box component='a' href='tel:8664527487' sx={linkSx}>
            (866) 452-7487
          </Box>
        </Box>
        <Box>
          Email{' '}
          <Box component='a' href='mailto:help@kariusdx.com' sx={linkSx}>
            help@kariusdx.com
          </Box>
        </Box>
      </Typography>
    )}
  </LoginModalShell>
);
